module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Publicado por")]), _c('span', {
    staticClass: "t6"
  }, [_c('br')]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Dreamspinner Press")]), _c('span', {
    staticClass: "t6"
  }, [_c('br')]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("5032 Capital Cir. SW")]), _c('span', {
    staticClass: "t6"
  }, [_c('br')]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Ste 2 PMB# 279")]), _c('span', {
    staticClass: "t6"
  }, [_c('br')]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Tallahassee, FL 32305-7886")]), _c('span', {
    staticClass: "t6"
  }, [_c('br')]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Esta historia es ficción. Los nombres, personajes, lugares y acontecimientos son producto de la imaginación del autor o usados para la ficción y cualquier similitud con personas vivas o muertas, empresas, hechos o escenarios es mera coincidencia.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Haciendo Promesas")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Copyright © 2010 by Amy Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Traducido por Rocío Pérez García")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Portada: Paul Richmond  http://www.paulrichmondstudio.com")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("La licencia de este libro pertenece exclusivamente al comprador original. Duplicarlo o reproducirlo por cualquier medio es ilegal y una violación de la ley internacional de Derechos de Autor. Este eBook no puede ser prestado legalmente o regalado a otros. Ninguna parte de este eBook puede ser compartida o reproducida sin el permiso expreso de la editorial. Para solicitar el permiso y resolver cualquier duda, contactar con Dreamspinner Press, 5032 Capital Cir. SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886 USA")]), _c('span', {
    staticClass: "t6"
  }, [_c('br')]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Publicado en los Estados Unidos de América")]), _c('span', {
    staticClass: "t6"
  }, [_c('br')]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Primera Edición ")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Noviembre, 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Edición eBook en Español: 978-1-62380-068-0 ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae2c032","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0